document.addEventListener('DOMContentLoaded', () => {
  const options = { weekday: 'short', month: 'short', day: 'numeric' };

  document.querySelectorAll('[data-estimated-delivery]').forEach((el) => {
    const minDays = parseInt(el.dataset.minDays, 10) || 3;
    const maxDays = parseInt(el.dataset.maxDays, 10) || 5;

    const minDate = new Date();
    minDate.setDate(minDate.getDate() + minDays);

    const maxDate = new Date();
    maxDate.setDate(maxDate.getDate() + maxDays);

    const minLabel = minDate.toLocaleDateString('en-IN', options);
    const maxLabel = maxDate.toLocaleDateString('en-IN', options);

    el.textContent = `Order today, get it between ${minLabel} - ${maxLabel}`;
  });
});
